import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PostAddIcon(props: IconProps) {
    return <Icon {...props} iconKey={"post_add"}/>
}
